import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { goBack } from "./actions";
export const template = (height, documentURL, documentType, fileName) => ({
    layout: {
        id: ROUTE.AS_ES_SAMPLE_DOCUMENT_VIEW,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "asESViewSampleDocument", type: WIDGET.AS_ES_VIEW_SAMPLE_DOCUMENT }
        ],
    },
    datastore: {
        asESViewSampleDocument: {
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            documentURL: documentURL,
            documentType: documentType,
            fileName: fileName
        }
    },
});
export const asESSampleDocumentViewMF = {
    onLoad: async ({ getHeight, network }, { documentURL, documentType, fileName }) => {
        return Promise.resolve(template(getHeight(), documentURL, documentType, fileName));
    },
    actions: {
        [ACTION.GO_BACK]: goBack
    },
    clearPrevious: true,
};
